import { render, staticRenderFns } from "./openAcctDc.vue?vue&type=template&id=2fde3e7c&scoped=true"
import script from "./openAcctDc.vue?vue&type=script&lang=js"
export * from "./openAcctDc.vue?vue&type=script&lang=js"
import style0 from "./openAcctDc.vue?vue&type=style&index=0&id=2fde3e7c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fde3e7c",
  null
  
)

export default component.exports